import Vue from 'vue'
import store from './store'
import StudentExchangeNonPartnerWidget from './StudentExchangeNonPartnerWidget.vue'
import VueCompositionAPI from '@vue/composition-api'
import { getAttributeValue } from "@/shared/filters/utils-filter"

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

let widgetEls = document.querySelectorAll('student-exchange-nonpartner-widget')

if (widgetEls.length) {
    widgetEls.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                return h(StudentExchangeNonPartnerWidget, {
                    props: {
                        language: getAttributeValue(el, 'language'),
                        labels: getAttributeValue(el, 'labels', true),
                        programId: Number(getAttributeValue(el, 'program-id')),
                        exchangeId: getAttributeValue(el, 'exchange-id'),
                        academicYearId: Number(getAttributeValue(el, 'academic-year-id'))
                    }
                })
            }
        })
    })
}
